import ECTItem from "./ectitem";


class ECTItemsList extends React.Component {
  constructor(props) {
    super(props);

    this.items = this.mergedData();
  }

  mergedData() {
      let allData = {
        courses: this.props.courses,
        trainingCourses: this.props.trainingCourses,
        trainingEvents: this.props.trainingEvents,
      }
  
      let i = 0;
      let newData = []
      Object.keys(allData).map((item) => {
        if (Object.keys(allData[item]).length) {
          Object.keys(allData[item]).map((subItem) => {

            newData[i] = {
              id: allData[item][subItem].id,
              title: allData[item][subItem].title,
              imageUrl: allData[item][subItem].imageUrl ?? '',
              eventDate: allData[item][subItem].eventDate ?? '',
              eventVenue: allData[item][subItem].eventVenue ?? '',
              eventAvailableSeat: allData[item][subItem].eventAvailableSeat ?? '',
              typeBlock: allData[item][subItem].typeBlock,
              trainingItems: (item == 'trainingCourses') ? this.getEvents(allData[item][subItem].id, this.props.index) : '',
              dateValidity: allData[item][subItem].dateValidity ?? 0
            }
            ++i;
            
          });
        }
      });
      return newData;
  }
  
  getEvents(id, key) {
    let events = [];
    let i = 0;
    if (this.props.trainingCoursesEvent)
    {
      this.props.trainingCoursesEvent.map((item) => {
        if (item.courseId == id && item.dateValidity == '0') {
          events[i] = {
            courseId: item.courseId,
            value: item.courseId + '_' + item.id,
            label: item.code + '-' + item.title,
            date: item.eventDate,
            venue: item.eventVenue,
            seats: item.eventAvailableSeat
          };
          ++i;
        }
      });
    }
    return events;
  }

  render() {
    return (
      <div className="ect-items-wrapper">
        <h1 className="ect-items-heading">Item(s)</h1>
        <div className="ect-items-list">
          <div className="row">
            {this.items.map(item => (
              <div key={item.id} className="col-xl-6">
                <ECTItem
                  id={item.id}
                  title={item.title}
                  date={item.date}
                  imageUrl={item.imageUrl}
                  eventDate={item.eventDate}
                  eventVenue={item.eventVenue}
                  eventAvailableSeat={item.eventAvailableSeat}
                  trainingDropdown={item.trainingItems}
                  typeBlock={item.typeBlock}
                  dateValidity={item.dateValidity}
                  index={this.props.index}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default ECTItemsList;


